import * as React from "react";

export const YouTubeIcon = ({
   className,
   ...props
}: React.SVGProps<SVGSVGElement>) => (
   <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <g clip-path="url(#clip0_175_704)">
         <path
            d="M13.3705 4.4001C13.3705 4.4001 13.2436 3.50381 12.8525 3.11025C12.3574 2.59229 11.8039 2.58975 11.55 2.55928C9.73203 2.42725 7.00254 2.42725 7.00254 2.42725H6.99746C6.99746 2.42725 4.26797 2.42725 2.45 2.55928C2.19609 2.58975 1.64258 2.59229 1.14746 3.11025C0.756445 3.50381 0.632031 4.4001 0.632031 4.4001C0.632031 4.4001 0.5 5.45381 0.5 6.50498V7.49014C0.5 8.54131 0.629492 9.59502 0.629492 9.59502C0.629492 9.59502 0.756445 10.4913 1.14492 10.8849C1.64004 11.4028 2.29004 11.3851 2.57949 11.4409C3.62051 11.5399 7 11.5704 7 11.5704C7 11.5704 9.73203 11.5653 11.55 11.4358C11.8039 11.4054 12.3574 11.4028 12.8525 10.8849C13.2436 10.4913 13.3705 9.59502 13.3705 9.59502C13.3705 9.59502 13.5 8.54385 13.5 7.49014V6.50498C13.5 5.45381 13.3705 4.4001 13.3705 4.4001ZM5.65684 8.68604V5.03232L9.16836 6.86553L5.65684 8.68604Z"
            fill="#1E3455"
         />
      </g>
      <defs>
         <clipPath id="clip0_175_704">
            <rect
               width="13"
               height="13"
               fill="white"
               transform="translate(0.5 0.5)"
            />
         </clipPath>
      </defs>
   </svg>
);
